// imports montreal_edge_letters_gotham_numbers_font.js
letterAdjust.x = 5;
letterAdjust.scale = 0.9;

var colors = {
		characters: {
			home: [
				"#d0202e"
			]
		},
		numbers: {
			home: [
				"#d0202e",
			]
		}
	},
	outlines = {
		characters: {
			width: 0
		},
		numbers: {
			width: 0
		}
	},
	special_Character_Adjustments = {
		period: {
			vertical: -5,
			horizontal: -2.5,
			scale_width: 15.5,
			scale_height: 15.5,
		}
	};